export const orderScooterAction = {
  FETCH_CHECKOUT_DATA: "FETCH_CHECKOUT_DATA",
  SET_ORDER_UI_STATE: "SET_ORDER_UI_STATE",
  RELOAD_SHOPCART: "RELOAD_SHOPCART",
  SET_FORM_DATA: "SET_FORM_DATA",
  ORDER_SCOOTER_CHECKOUT: "ORDER_SCOOTER_CHECKOUT",
  GET_FORM_POST_DATA: "GET_FORM_POST_DATA",
  ORDER_MODIFY_CHECKOUT: "ORDER_MODIFY_CHECKOUT",
  MODIFY_SHOPPINGCART_DATA: "MODIFY_SHOPPINGCART_DATA",
  GET_PDISTORE_OPTIONS: "GET_PDISTORE_OPTIONS",
  GET_PAYMENT_INIT_DATA: "GET_PAYMENT_INIT_DATA",

  fetchCheckoutData: (bag, orderNo, winner) => ({
    type: orderScooterAction.FETCH_CHECKOUT_DATA,
    payload: { bag: bag, orderNo: orderNo, winner: winner },
  }),

  setOrderUIState: (data, actionName) => ({
    name: actionName,
    type: orderScooterAction.SET_ORDER_UI_STATE,
    payload: data,
  }),

  reloadShopCart: (newData) => ({
    type: orderScooterAction.RELOAD_SHOPCART,
    payload: newData,
  }),

  setFormData: (name, data) => ({
    type: orderScooterAction.SET_FORM_DATA,
    payload: { name: name, data: data },
  }),

  orderScooterCheckout: (resolve) => ({
    type: orderScooterAction.ORDER_SCOOTER_CHECKOUT,
    payload: { resolve },
  }),

  getFormatPostData: (name, orderNo) => ({
    type: orderScooterAction.GET_FORM_POST_DATA,
    payload: { name: name, orderNo: orderNo },
  }),

  getInitPaymentData: () => ({
    type: orderScooterAction.GET_PAYMENT_INIT_DATA,
  }),

  orderModifyCheckout: (resolve) => ({
    type: orderScooterAction.ORDER_MODIFY_CHECKOUT,
    payload: { resolve },
  }),
  modifyShoppingCartData: (data) => ({
    type: orderScooterAction.MODIFY_SHOPPINGCART_DATA,
    payload: data,
  }),
  getPDIStoreOptions: (data) => ({
    type: orderScooterAction.GET_PDISTORE_OPTIONS,
    payload: data,
  }),
}
